<template>
  <div :class="this.wrapperClass">
    <v-avatar
        :class="this.avatarClass"
        :username="this.username"
        :initials="this.initials"
        :background-color="this.backgroundColor"
        :color="this.color"
        :custom-style="this.customStyle"
        :inline="this.inline"
        :size="this.size"
        :src="this.src"
        :rounded="this.rounded"
        :lighten="this.lighten"
        v-on="$listeners"></v-avatar>
  </div>
</template>

<script>
import Avatar from 'vue-avatar';
import eventBus from "../mixins/eventBus"
export default {

  name: "ReactiveAvatar",

  components: { 'v-avatar': Avatar },

  inheritAttrs: true,

  props: {
    wrapperClass: {
      type: String,
      default: ''
    },
    avatarClass: {
      type: String,
      default: ''
    },
    username: {
      type: String
    },
    initials: {
      type: String
    },
    backgroundColor: {
      type: String
    },
    color: {
      type: String
    },
    customStyle: {
      type: Object
    },
    inline: {
      type: Boolean
    },
    size: {
      type: Number,
      default: 50
    },
    initialSrc: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: true
    },
    lighten: {
      type: Number,
      default: 80
    }
  },

  data () {
    return {
      src: this.initialSrc
    }
  },

  created() {
    let self = this;

    eventBus.$on('avatar-src-changed', (src) => {
      self.src = src;
    });
  },
}
</script>